module.exports = __webpack_public_path__ + "static/media/beauty-clipart-beauty-care-4.7c049773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/beauty-clipart-beauty-care-4.png
// module id = 231
// module chunks = 1